<template>
<div class="judges section" id="judge">
  <div class="layout-content" v-for="(judgesType, j) in data" :key="j">
    <SubTitle class="sub-title" :text="judgesType.title.h1" :tip="judgesType.title.tip" />

    <div class="content">
      <article
        class="content-item"
        :class="{
          'is-placeholder': item.placeholder,
          'is-top-row': index < 4
        }"
        v-for="(item, index) in judgesType.list"
        :key="index"
      >
        <div class="content-img-wrap">
          <img v-if="item.headImg" class="content-img" :src="item.headImg" :alt="`${item.name}学术顾问照片`">
          <div v-else class="content-img-placeholder" aria-hidden="true">
            <span>{{ placeholderText(item) }}</span>
          </div>
        </div>
        <div class="content-text">
          <template v-if="!item.placeholder">
            <p class="content-text-name">{{item.name}}</p>
            <p class="content-text-title" v-html="item.title" />
          </template>
          <p v-else class="content-pending">{{ isEnLang ? 'To be announced' : '信息待补充' }}</p>
        </div>
      </article>
    </div>
  </div>
</div>
</template>

<script>
import SubTitle from '@/components/SubTitle'
import { mapState } from 'vuex'

export default {
  props: ['data'],
  components: {
    SubTitle
  },
  computed: {
    ...mapState(['isEnLang'])
  },
  methods: {
    placeholderText (item) {
      if (this.isEnLang) return item.placeholder ? 'Adviser TBA' : 'Photo pending'
      return item.placeholder ? '顾问待补充' : '照片待补充'
    }
  }
}
</script>

<style lang="scss" scoped>
.judges {
  scroll-margin-top: 90px;
  background: $bgGrey;
  color: #303030;

  @include mobile {
    scroll-margin-top: 55px;
  }
}

.content {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 226px));
  gap: 28px 18px;
  align-items: stretch;
  justify-content: center;
  margin-top: 8px;

  @include mobile {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px 12px;
    margin-top: 5px;
  }
}

.content-item {
  grid-column: auto;

  @include mobile {
    grid-column: auto !important;
  }
}

.content-item {
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  background: $white;
  border: 1px solid #e8edf4;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(18, 28, 52, .06);
  transition: transform .25s ease, box-shadow .25s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 14px 32px rgba(18, 28, 52, .12);
  }

  &.is-placeholder {
    border: 1px dashed #c9cdd4;
    box-shadow: none;

    &:hover {
      transform: none;
      box-shadow: none;
    }
  }

  &.is-top-row {
    position: relative;
    border-top: 1px solid #e8edf4;

    &::after {
      display: none;
    }
  }
}

@media (max-width: 1100px) and (min-width: 701px) {
  .content {
    grid-template-columns: repeat(3, minmax(0, 226px));
    gap: 22px 14px;
  }
}

.content-img-wrap {
  width: 100%;
  aspect-ratio: 5 / 4;
  overflow: hidden;
  background: linear-gradient(145deg, #f5f7fb 0%, #edf1f7 100%);
}

.content-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  padding: 8px 12px 0;
  box-sizing: border-box;
}

.content-img-placeholder {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 18px;
  box-sizing: border-box;
  color: #9298a3;
  background: linear-gradient(145deg, #f4f5f7, #e4e7ec);

  &::before {
    content: '';
    position: absolute;
    top: 24%;
    left: 50%;
    width: 23%;
    aspect-ratio: 1;
    border-radius: 50%;
    background: #c8cdd5;
    transform: translateX(-50%);
  }

  &::after {
    content: '';
    position: absolute;
    top: 52%;
    left: 50%;
    width: 50%;
    height: 28%;
    border-radius: 50% 50% 12% 12%;
    background: #c8cdd5;
    transform: translateX(-50%);
  }

  span {
    position: relative;
    z-index: 1;
    font-size: 12px;
    letter-spacing: 1px;
  }
}

.content-text {
  flex: 1;
  box-sizing: border-box;
  padding: 20px 16px 22px;

  @include mobile {
    width: 100%;
    height: auto;
    padding: 14px 14px 18px;
  }
}

.content-text-name {
  margin-bottom: 8px;
  font-size: 17px;
  font-family: Alibaba-PuHuiTi-Heavy;
  color: #000000;
  line-height: 28px;
  overflow-wrap: anywhere;

  @include mobile {
    margin-bottom: 6px;
    font-size: 14px;
    line-height: 20px;
  }
}

.content-pending {
  color: #9298a3;
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 1px;
}

.content-text-title {
  font-size: 13px;
  font-weight: 400;
  color: #333842;
  line-height: 22px;

  @include mobile {
    font-size: 11px;
    line-height: 18px;
  }
}
</style>
